// extracted by mini-css-extract-plugin
export var animationDuration = "200ms";
export var button = "NotificationPopUp-module--button--6e01d";
export var buttons = "NotificationPopUp-module--buttons--0e012";
export var fadeInBottom = "NotificationPopUp-module--fadeInBottom--ac2f4";
export var fadeOutBottom = "NotificationPopUp-module--fadeOutBottom--e489d";
export var link = "NotificationPopUp-module--link--e586c";
export var modal = "NotificationPopUp-module--modal--a514b";
export var visible = "NotificationPopUp-module--visible--ec416";